export default function genererRole() {
  return {
    name: '',
    displayName: '',
    normalizedName: '',
    description: '',
    grantedPermissions: [],
  };
}
